<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Deacon of Death</span></p>
<p class="bk-title1"><span>Sam Smithers, the Serial Killer Next Door</span></p>
<p class="authorname"><span>Fred Rosen</span></p>
<p class="center" style="margin-top:80px;"><img alt="" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?62db67c2